var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('config-card', { ref: "form", attrs: { "title": "是否需要研发介入", "form-config": _vm.formConfig, "form-value": _vm.formValue, "form-item-list": _vm.formItemList } });
};
var staticRenderFns = [];

export { render, staticRenderFns };